const state = {
  user: {
    firstName: "firstName",
    lastName: "lastName",
    firstFurigana: "firstFurigana",
    lastFurigana: "lastFurigana",
    phoneNumber: "phoneNumber",
    postal: "postal",
    prefecture: "prefecture",
    cities: "cities",
    address: "address",
    roomNumber: "roomNumber",
    email: "email@",
    emailConfirm: "emailConfirm",
    password: "password",
    passwordConfirm: "passwordConfirm",
    deliveryType: "other",
    deliveryFirstName: "deliveryFirstName",
    deliveryLastName: "deliveryLastName",
    deliveryFistFurigana: "deliveryFistFurigana",
    deliveryLastFurigana: "deliveryLastFurigana",
    deliveryPostal: "deliveryPostal",
    deliveryPrefecture: "deliveryPrefecture",
    deliveryCities: "deliveryCities",
    deliveryAddress: "deliveryAddress",
    deliveryRoomNumber: "deliveryRoomNumber"
  }
};
const getters = {
  user(state) {
    return state.user;
  }
};

const actions = {};

const mutations = {};

export default {
  state,
  actions,
  mutations,
  getters
};
